"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = require("styled-system");

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const arrow = p => ({
  backgroundRepeat: "no-repeat, repeat",
  backgroundPosition: "right .7em top 50%, 0 0",
  backgroundImage: `url('data:image/svg+xml;charset=US-ASCII,${window.encodeURIComponent(
  // eslint-disable-next-line
  `<svg width="12" height="8" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L10.59.59 6 5.17 1.41.59 0 2l6 6z" fill="${(0, _styledSystem.get)(p.theme.colors, p.color)}" fill-rule="nonzero"/></svg>`)}')`
});

const Select = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Select",
  componentId: "nc6bz5-0"
})(["appearance:none;", ""], arrow);

Select.defaultProps = {
  as: "select",
  bg: "white",
  p: 2,
  border: 1,
  fontSize: 1,
  borderColor: "palette.ink.lighter",
  color: "palette.ink.light",
  width: "100%"
};

const SelectBox = (_ref) => {
  let { label, description, children } = _ref,
      props = _objectWithoutProperties(_ref, ["label", "description", "children"]);

  return _react2.default.createElement(
    _Text2.default,
    {
      as: "label",
      fontSize: 0,
      fontWeight: 500,
      color: "palette.ink.light",
      lineHeight: "24px"
    },
    label,
    _react2.default.createElement(
      Select,
      props,
      children
    ),
    description
  );
};

SelectBox.propTypes = {
  label: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};

exports.default = SelectBox;